import type { FishingTrip } from "./contracts";

export const organizationLabels: Record<string, string> = {
  shareholding_association: "Kalastusosakaskunta",
  fishery_area: "Kalatalousalue",
  private_water_owner: "Yksityinen vesialueen omistaja",
  state_operator: "Valtion toimija",
  permit_issuer: "Luvanmyöntäjä",
  permit_seller: "Luvanmyyjä",
  reseller: "Jälleenmyyjä",
  service_provider: "Palveluntarjoaja",
};

export const roleLabels: Record<string, string> = {
  owner: "Omistaja",
  admin: "Ylläpitäjä",
  editor: "Muokkaaja",
  support: "Asiakaspalvelu",
  viewer: "Katselija",
};

export const relationLabels: Record<string, string> = {
  owner: "Omistaa vesialueen",
  manager: "Hallinnoi aluetta",
  fishery_area: "Kalatalousalue",
  permit_issuer: "Myöntää lupia",
  permit_seller: "Myy lupia",
  service_provider: "Palveluntuottaja",
};

export const capabilityLabels: Record<string, string> = {
  manage_areas: "Hallinnoi alueita",
  issue_permits: "Myöntää lupia",
  sell_permits: "Myy lupia",
  receive_payments: "Vastaanottaa maksuja",
  manage_orders: "Käsittelee tilauksia",
  handle_refunds: "Käsittelee palautuksia",
  view_financial_reports: "Näkee talousraportit",
};

export const consumerActivityLabels: Record<
  FishingTrip["activity"],
  string
> = {
  lure_fishing: "Viehekalastus",
  angling: "Onginta",
  ice_fishing: "Pilkkiminen",
  net_fishing: "Verkkokalastus",
};
